export default "__VITE_ASSET__DX3yKLyM__"